import React from "react";
import { useTranslation } from "react-i18next";
import {
  RemoveUserIcon,
  InactiveParticipantIcon,
} from "fe-shared/src/components/Icons";
import styles from "./InactiveStatus.module.scss";

interface Props {
  isEmployee?: boolean;
}

const InactiveStatus = ({ isEmployee = false }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.inactiveStatusWrapper}>
      {isEmployee ? (
        <RemoveUserIcon width={16} height={16} fillColor={null} />
      ) : (
        <InactiveParticipantIcon fillColor={null} />
      )}

      <span>{t("inactive")}</span>
    </div>
  );
};

export default InactiveStatus;
